import Layout from "../../components/layOutWrapper/layOutWrapper";
import ShowAllVehicles from "../../components/vehicles/showAllVehicles";

export default function VehiclesListView () {
    return (
        <>
            <Layout children={ShowAllVehicles()} sectionTitle="Lista de vehículos"/>
        </>
    )
}